<template>
  <div class="modal fade" id="myModal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" :style="`width:${modalWidth}px`" @click.stop>
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body" :class="customBodyClass">
          納品情報を登録しました。 <br>
          納品管理番号： {{deliveryNo}} <br> <br>
          <p>
            登録した納品情報に従って、STOCKCREW倉庫への発送を行ってください。
          </p>
          <br>
          <p>
            <span class="text-danger">発送する際は、外装ラベルを出力して輸送箱へ貼付けしてください。</span> <br>
            ※外装ラベルは、納品照会画面からも出力いただけます。
          </p>
          <button class="btn btn-primary mr-b-10" @click="$emit('downloadPackingLabel')">外装ラベル出力</button>
          <p>
            <span class="text-danger">※受取金額をご確認ください</span> <br>
            セルモンに出品している商品の場合、「商品管理 > 商品一覧」 画面にて <br>
            STOCKCREW倉庫商品の受取金額を確認・変更いただくことが可能です。
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning close-btn" data-dismiss="modal" @click="$emit('close')">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    deliveryNo: {
      type: String,
      default: null
    },
    customHide: {
      type: Boolean,
      default: false
    },
    modalWidth: {
      type: Number,
      default: 400
    },
    customBodyClass: {
      type: String,
      default: null
    }
  },
  mounted () {
    $('#myModal').modal('show')
    if (this.customHide) {
      $('#myModal').on('hidden.bs.modal', (e) => {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      })
    }
  },
  beforeDestroy () {
    setTimeout(() => {
      $('body').attr({
        style: null
      })
    }, 700)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseSc/components/ModalAlertAdded.vue